import * as React from 'react';
import { useSelector } from 'react-redux';
import { canShowOnlineSelector } from './selectors';
import { FloatingLabel } from '../../components/FloatingLabel';
import { ApplicationContext } from '../../reactContexts/applicationContext';

export const OnlineShowLabelContainer: React.FC = () => {
  const { config } = React.useContext(ApplicationContext);
  const canShowOnline = useSelector(canShowOnlineSelector);

  if (!config || !config.get<boolean>('onlineShow.isEnabled') || !canShowOnline) {
    return null;
  }

  return (
    <FloatingLabel
      labelText="Онлайн-показ"
      tooltipTitle="Выбирайте не выходя из дома"
      tooltipText="Вам могут провести онлайн-показ объекта при помощи видеозвонка в WhatsApp, Viber, FaceTime или другой программы"
    />
  );
};

OnlineShowLabelContainer.displayName = 'OnlineShowLabelContainer';
